import * as React from "react";

import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { AnyType } from "../util/types";

const Container = styled.div`
  width: 150px;
  height: 200px;
  border-radius: 5px;
  position: relative;
  overflow: hidden;
  margin: 0 10px 16px;
  cursor: pointer;
  .ft {
    height: 30px;
    background-color: rgba(0, 0, 0, 0.3);
    color: #fff;
    font-size: 14px;
    text-indent: 10px;
    line-height: 14px;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 150px;
    line-height: 30px;
  }
  img {
    width: 150px;
    height: 200px;
  }
`;

interface GroupItemProp {
  item: AnyType;
}

const DonateItem: React.FunctionComponent<GroupItemProp> = ({ item }) => {
  const navigate = useNavigate();

  const goDetail = (x: any) => {
    navigate(`/group/donatedetail?id=${item.id}`);
  };

  return (
    <Container onClick={goDetail}>
      <img src={item.logoFileName} alt="" />
      <div className="ft">{item.name} 乐捐情况</div>
    </Container>
  );
};

export default DonateItem;
